import React, { useState } from "react";
import cn from "classnames";
import styles from "./TotesDetailsPage.module.sass";
import Card from "../../../components/Card";
import AccessControl from "../../../HOC/AccessControl";
import Icon from "../../../components/Icon";
import DeleteSingleTote from "../Modals/DeleteSingleTote";
import EmptySingleTote from "../Modals/EmptySingleTote";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ToteDetailsTable from "./ToteDetailsTable/index";
import CustomAlert from "../../../components/CustomAlert";

const Totes = () => {
  const { toteId } = useParams();
  const { showAlert } = CustomAlert();
  const [refetchTrigger, setRefetchTrigger] = useState(0);
  const [checkedItems, setCheckedItems] = useState({});
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(100);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const savedPageSize = localStorage.getItem("itemsPerPage");
    return savedPageSize ? parseInt(savedPageSize, 10) : 10;
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEmptyModalVisible, setIsEmptyModalVisible] = useState(false);
  const [toteMarkedToDelete, setToteMarkedToDelete] = useState(null);
  const [toteMarkedToEmpty, setToteMarkedToEmpty] = useState(null);
  const [searchParams] = useSearchParams();
  const [toteStatus, setToteStatus] = useState("");
  const [toteCount, setToteCount] = useState(0);
  const [actionType, setActionType] = useState("removeOrders");
  const navigate = useNavigate();


  const handleSingleDeleteToteModalClose = () => {
    setToteMarkedToDelete(null);
    setIsDeleteModalVisible(false)
  };

  const handleSingleEmptyToteModalClose = () => {
    setToteMarkedToEmpty(null);
    setIsEmptyModalVisible(false)
  };

  const handleItemsPerPageChange = (newPageSize) => {
    setItemsPerPage(newPageSize);
    localStorage.setItem("itemsPerPage", newPageSize.toString());
  };

  const handleCheckboxChange = (event, newCheckedItems = null, id = null) => {
    if (newCheckedItems) {
      setCheckedItems(newCheckedItems);
    } else if (id !== null) {
      setCheckedItems((prev) => ({
        ...prev,
        [id]: !prev[id]
      }));
    }
  };

  const handleSingleToteDeleteSuccess = async () => {
    setToteMarkedToDelete(null);
    setRefetchTrigger((prev) => prev + 1);
  };

  const handleSingleEmptyToteSuccess = async () => {
    setToteMarkedToEmpty(null);
    setRefetchTrigger((prev) => prev + 1);
  };

  const handleDeleteClick = () => {
    if (toteCount === 0) {
      showAlert(
        "No Orders in Tote",
        "There are no orders in this tote to delete.",
        "info",
        "OK",
        "",
        null,
        false,
        true,
        false
      );
      return;
    }
    const orderIds = Object.keys(checkedItems).filter(id => checkedItems[id]);
    if (orderIds.length === 0) {
      showAlert(
        "Warning",
        "No orders selected to remove",
        "info",
        "OK",
        "",
        null,
        false,
        true,
        false
      );
      return;
    }
    setIsDeleteModalVisible(true);
  };

  const handleEmptyClick = () => {
    if (toteCount === 0) {
      showAlert(
        "Tote Is Empty",
        "This tote does not contain any orders.",
        "info",
        "OK",
        "",
        null,
        false,
        true,
        false
      );
      return;
    }
    setIsEmptyModalVisible(true);
  };
  const formatStatus = (status) => {
    if (!status) return "-";
    const formattedValue = status.replace(/_/g, " ");
    const capitalizedValue = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
    return (
      <div
        className={cn(styles.purchase, {
          "status-role-active": capitalizedValue === "EMPTY",
          "status-role-inactive": capitalizedValue !== "EMPTY",
        })}
      >
        {capitalizedValue}
      </div>
    );
  };
  const handleDeleteComplete = () => {
    navigate('/totes');
};

  return (
    <>
      <Card className={styles.Card}>
        <div className="flex justify-between items-center  mb-12">
          <div className="flex gap-20px">
            <div className={cn(styles.h4, styles.title)}> {toteId}</div>
            <div className={styles.countTag}>
              {String(toteCount).padStart(2, '0')}
            </div>
            <div>{formatStatus(toteStatus)}</div>

          </div>
          <div className="flex items-center space-x-2">
              <Link
                className={cn("button-stroke button-small", styles.backbutton)}
                to="/totes"
              >
                <Icon name="arrow-left" size="24" />
                <span>Back</span>
              </Link>           
            <AccessControl moduleCode="9a7df7" requiredPrivilege="82c962">
              <button
                className={cn(
                  "button-clear-stroke button-clear-stroke-red button-small",
                  styles.button
                )}
                onClick={handleDeleteClick}
              >
                Remove
              </button>
            </AccessControl>
        
            <AccessControl moduleCode="9a7df7" requiredPrivilege="3dea03">
              <button
                className={cn("button", styles.deletebutton)}
                onClick={handleEmptyClick}
              >
                <span>Empty Tote</span>
              </button>
            </AccessControl>
          </div>
        </div>

        <DeleteSingleTote 
          handleModalClose={handleSingleDeleteToteModalClose}
          handleSuccess={handleSingleToteDeleteSuccess}
          isModalVisible={isDeleteModalVisible}
          toteMarkedToDelete={toteId}
          onDeleteComplete={handleDeleteComplete}
          actionType={actionType}
          checkedItems={checkedItems}
        />

        <EmptySingleTote
          handleModalClose={handleSingleEmptyToteModalClose}
          handleSuccess={handleSingleEmptyToteSuccess}
          isModalVisible={isEmptyModalVisible}
          toteMarkedToEmpty={toteId}
        />
       
      </Card>
      <div>
        <ToteDetailsTable
          handleCheckboxChange={handleCheckboxChange}
          checkedItems={checkedItems}
          page={page}
          setPage={setPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={handleItemsPerPageChange}
          setTotalItems={setTotalItems}
          refetchTrigger={refetchTrigger}
          setToteMarkedToDelete={setToteMarkedToDelete}
          setToteMarkedToEmpty={setToteMarkedToEmpty}         
          setToteCount={setToteCount}
          setToteStatus={setToteStatus}
          
        />
      </div>
    </>
  );
};

export default Totes;
